export default __webpack_public_path__ + "static/media/watch_the_gameplay.0c9aaeaf.png";